// Author yujiabei
// Date 2021-08-27 08:29:18

class EmArchBdaREafmBarem {
constructor({
        id = null,
        baremIdEafm = '',
        eafmNodeCode = '',
        eafmName = '',
        baremIdBda = '',
        bdaName = '',
        bdaCode = '',
        remark = ''}
= {}) {
    this.id = id;
    this.baremIdEafm = baremIdEafm;
    this.eafmNodeCode = eafmNodeCode;
    this.eafmName = eafmName;
    this.baremIdBda = baremIdBda;
    this.bdaName = bdaName;
    this.bdaCode = bdaCode;
    this.remark = remark;
}
}

function newEntity() {
return new EmArchBdaREafmBarem();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.em.archive.emArchBdaREafmBarem.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'baremIdEafm',
        label: 'label.em.archive.emArchBdaREafmBarem.grid.baremIdEafm',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'eafmNodeCode',
        label: 'label.em.archive.emArchBdaREafmBarem.grid.eafmNodeCode',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'eafmName',
        label: 'label.em.archive.emArchBdaREafmBarem.grid.eafmName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'baremIdBda',
        label: 'label.em.archive.emArchBdaREafmBarem.grid.baremIdBda',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'bdaName',
        label: 'label.em.archive.emArchBdaREafmBarem.grid.bdaName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'bdaCode',
        label: 'label.em.archive.emArchBdaREafmBarem.grid.bdaCode',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'remark',
        label: 'label.em.archive.emArchBdaREafmBarem.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        }
    ])}

const filter = {
    idFilter : "",
    idListFilter : "",
    baremIdEafmFilter : "",
    baremIdBdaFilter : ""
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'baremIdEafmFilter',
        label: 'label.em.archive.emArchBdaREafmBarem.filter.baremIdEafm',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emAdmFactoryModelEafm'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'baremIdBdaFilter',
        label: 'label.em.archive.emArchBdaREafmBarem.filter.baremIdBda',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emArchBasicData'
            ,correspondingField: 'id'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'baremIdEafm',
        label: 'label.em.archive.emArchBdaREafmBarem.entity.baremIdEafm',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,required: true
            ,entity: 'emAdmFactoryModelEafm'
            ,correspondingField: 'id'
            ,fieldsBindingByEntityModalSelected: '{"eamfNodeCode":"nodeCode","eafmName":"name"}'
                }
        },
        {
        key: 'eafmNodeCode',
        label: 'label.em.archive.emArchBdaREafmBarem.entity.eafmNodeCode',
        sortable: true,
        disabled: true,
        form: {
        type: 'input'
                }
        },
        {
        key: 'eafmName',
        label: 'label.em.archive.emArchBdaREafmBarem.entity.eafmName',
        sortable: true,
        disabled: true,
        form: {
        type: 'input'
                }
        },
        {
        key: 'baremIdBda',
        label: 'label.em.archive.emArchBdaREafmBarem.entity.baremIdBda',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,required: true
            ,entity: 'emArchBasicData'
            ,correspondingField: 'id'
            ,fieldsBindingByEntityModalSelected: '{"bdaCode":"code","bdaName":"name"}'
                }
        },
        {
        key: 'bdaName',
        label: 'label.em.archive.emArchBdaREafmBarem.entity.bdaName',
        sortable: true,
        disabled: true,
        form: {
        type: 'input'
                }
        },
        {
        key: 'bdaCode',
        label: 'label.em.archive.emArchBdaREafmBarem.entity.bdaCode',
        sortable: true,
        disabled: true,
        form: {
        type: 'input'
                }
        },
        {
        key: 'remark',
        label: 'label.em.archive.emArchBdaREafmBarem.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {EmArchBdaREafmBarem, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
